// Chakra imports
import {
  Avatar,
  AvatarGroup,
  Box, Stat,
  StatLabel,
  StatNumber,
  Button,
  Flex,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Badge,
  Spacer,
  Grid,
  SimpleGrid,
  Icon,
  Image,
  Link,
  Switch,
  Table,
  TableContainer,
  TableCaption,
  Thead,
  Th,
  Tfoot,
  Tbody,
  Tr,
  Td,
  Text,
  useColorMode,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { useHistory, Redirect } from "react-router-dom";
import NiceButton from "components/NiceButton/NiceButton.js";

// Assets
import rocket from "assets/img/rocket.png";
import rocketBlue from "assets/img/rocket_blue.png";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import IconBox from "components/Icons/IconBox";
import CardHeader from "components/Card/CardHeader";
import { getGlobal } from "config/global";
import { RiHotelLine,RiFile3Fill } from "react-icons/ri";
import moment from 'moment-jalaali'
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { GlobeIcon, WalletIcon, RocketIcon } from "components/Icons/Icons";
import report from "api/plan/report-plan";
import IncreaseButton from "components/IncreaseBalance/index";
import Scrollbars from "react-custom-scrollbars";
import activePlan from "api/plan/active-plan";

function Profile() {
  const { colorMode } = useColorMode();
  const history = useHistory();
  let me = getGlobal("me")
  // Chakra color mode
  const { isOpen, onOpen, onClose } = useDisclosure()
  const iconBoxInside = useColorModeValue("white", "white");
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const textColor = useColorModeValue("gray.700", "white");
  const iconColor = useColorModeValue("blue.500", "white");
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [isActiveLoading, setIsActiveLoading] = useState({});
  const [selected, setSelected] = useState(null);
  function active_plan() {
    let n = isActiveLoading
    n[selected._id] = true
    setIsActiveLoading(n)
    activePlan(selected._id).then((result) => {
      console.log(result)
      location.reload()
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsActiveLoading({})
      onClose()
    })
  }
  useEffect(() => {
    setIsLoading(true)
    report().then((result) => {
      setReportData(result.data)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }, [reload])
  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px", lg: "100px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px' mb='20px'>
        <Card minH='125px'>
          <Flex direction='column'>
            <Flex
              flexDirection='row'
              align='center'
              justify='center'
              w='100%'
              mb='25px'>
              <Stat me='auto'>
                <StatLabel
                  fontSize='xs'
                  color='gray.400'
                  fontWeight='bold'
                  textTransform='uppercase'>
                  تعداد نمایشگاه
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color={textColor} >
                    {reportData?.tour || "0"} مورد
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius='50%'
                as='box'
                h={"45px"}
                w={"45px"}
                bg={iconBlue}>
                <RiHotelLine h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color='gray.400' fontSize='sm'>
              تعداد مجاز: {" "}
              <Text as='span' color='green.400'>
                {reportData?.limit?.tour || "0"}
                {" "}
              </Text>
              مورد
            </Text>
            <Text hidden={reportData?.limit?.tour > reportData?.tour} color='red.400' fontSize='xs'>
              موارد بیشتر از محدودیت قفل خواهند شد.
            </Text>
          </Flex>
        </Card>
        <Card minH='125px'>
          <Flex direction='column'>
            <Flex
              flexDirection='row'
              align='center'
              justify='center'
              w='100%'
              mb='25px'>
              <Stat me='auto'>
                <StatLabel
                  fontSize='xs'
                  color='gray.400'
                  fontWeight='bold'
                  textTransform='uppercase'>
                  حجم فایل‌ها
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color={textColor}>
                    {reportData?.fileSize ? (Math.trunc(reportData?.fileSize) + " مگابایت") : "0"}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius='50%'
                as='box'
                h={"45px"}
                w={"45px"}
                bg={iconBlue}>
                <RiFile3Fill h={"64px"} w={"64px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color='gray.400' fontSize='sm'>
              مقدار مجاز: {" "}
              <Text as='span' color='green.400'>
                {reportData?.limit?.file || "نامشخص"}
                {" "}
              </Text>
              مگابایت
            </Text>
            <Text hidden={reportData?.limit?.file > reportData?.fileSize} color='red.400' fontSize='xs'>
              موارد بیشتر از محدودیت حذف خواهند شد.
            </Text>
          </Flex>
        </Card>
        <Card minH='125px'>
          <Flex direction='column'>
            <Flex
              flexDirection='row'
              align='center'
              justify='center'
              w='100%'
              mb='25px'>
              <Stat me='auto'>
                <StatLabel
                  fontSize='xs'
                  color='gray.400'
                  fontWeight='bold'
                  textTransform='uppercase'>
                  موجودی
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color={textColor} >
                    {(me?.balance ? (+me?.balance).toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0) + " تومان"}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius='50%'
                as='box'
                h={"45px"}
                w={"45px"}
                bg={iconBlue}>
                <WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text fontSize='sm'>
              <Text as='span' color='gray.100' >
                <IncreaseButton />
              </Text>
            </Text>
          </Flex>
        </Card>
        <Card minH='125px'>
          <Flex direction='column'>
            <Flex
              flexDirection='row'
              align='center'
              justify='center'
              w='100%'
              mb='25px'>
              <Stat me='auto'>
                <StatLabel
                  fontSize='xs'
                  color='gray.400'
                  fontWeight='bold'
                  textTransform='uppercase'>
                  باقی مانده از {me?.plan?.title || "پایه"}
                </StatLabel>
                <Flex>
                  <StatNumber fontSize='lg' color={textColor} >
                    {(me.expireIn ? (moment().diff(moment(me.expireIn), 'days') * -1) + " روز" : "بدون محدودیت")}
                  </StatNumber>
                </Flex>
              </Stat>
              <IconBox
                borderRadius='50%'
                as='box'
                h={"45px"}
                w={"45px"}
                bg={iconBlue}>
                <RocketIcon h={"24px"} w={"24px"} color={iconBoxInside} />
              </IconBox>
            </Flex>
            <Text color='gray.400' fontSize='sm'>
              از {" "}
              <Text as='span' color='green.400'>
                {me?.plan?.duration && me?.plan?.duration > 0 ? me?.plan?.duration : "نامحدود"}{" "}
              </Text>
              روز
            </Text>
          </Flex>
        </Card>
      </SimpleGrid>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 3 }} spacing={{ sm: '0px', md: '24px', xl: '24px' }} mb='24px'>
        <GridItem colSpan={1}>
          <Card p='16px' h={"100%"} >
            <CardHeader p='12px 5px' mb='12px'>
              <Text fontSize='md' color={textColor} fontWeight='bold'>
                پلن فعال
              </Text>
            </CardHeader>
            <CardBody px='5px'>
              <Flex direction='column'>
                <Flex align='center' mb='20px'>
                  <Image display={{ sm: "none", md: "none", xl: "block" }} borderRadius={"10px"} src={colorMode == "dark" ? rocket : rocketBlue}></Image>
                </Flex>
                <Flex align='center' mb='20px'>

                  <Text fontSize='sm'>
                    عنوان پلن
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='lg' colorScheme='blue' variant='solid'>
                    {me?.plan?.title || "پایه"}
                  </Badge>
                  <Badge hidden={!reportData?.limit?.trial} ml='1' fontSize='xs' colorScheme='blue' variant='solid'>
                    {reportData?.limit?.trial ? "آزمایشی" : ""}
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    تغییر آدرس خانه
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={reportData?.limit?.home ? "green" : "red"} variant='outline'>
                    {reportData?.limit?.home ? "دارد" : "ندارد"}
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    صفحه فرود
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={reportData?.limit?.landing ? "green" : "red"} variant='outline'>
                    {reportData?.limit?.limit ? "دارد" : "ندارد"}
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    تور مجازی
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.tour}{" "}مورد
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    ایستگاه
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.tour}{" "}تا در هر نمایشگاه
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    منو
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.menu}{" "}تا در هر  نمایشگاه
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    پاپ آپ
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.popup}{" "}تا در هر  نمایشگاه
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    مارکر
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.marker}{" "}تا در هر  ایستگاه
                  </Badge>
                </Flex>
                <Flex align='center' mb='20px'>
                  <Text fontSize='sm'>
                    فایل
                  </Text>
                  <Spacer />
                  <Badge ml='1' fontSize='xs' colorScheme={colorMode == "dark" ? "navy" : "gray"} variant='outline'>
                    {reportData?.limit?.file}{" "}مگابایت
                  </Badge>
                </Flex>
              </Flex>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem colSpan={{ sm: 1, md: 1, xl: 2 }} mt={{ sm: "24px", md: "0px", xl: "0" }}>
          <Card p='16px'>
            <CardHeader p='12px 5px' mb='12px'>
              <Text fontSize='md' color={textColor} fontWeight='bold'>
                فعالسازی پلن
              </Text>
            </CardHeader>
            <CardBody px='5px'>
              <Box>
                <TableContainer>
                  <Scrollbars
                    style={{ height: "720px" }}>
                    <Table variant='simple' data-scroll="true" style={{ overflow: "auto" }}>
                      <TableCaption><Link  onClick={() => { history.push("/admin/support") }}>جهت  مشاوره با پشتیبانی تماس بگیرید.</Link></TableCaption>
                      <Tbody>
                        <Tr bg={colorMode == "dark" ? "navy.900" : "gray.100"}>
                          <Td fontSize={"sm"}>عنوان</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td fontSize={"sm"}>{item.title}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>تغییر آدرس خانه</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.home ?
                                <Badge ml='1' fontSize='xs' colorScheme={"green"} variant='outline'>
                                  دارد
                                </Badge>
                                :
                                <Badge ml='1' fontSize='xs' colorScheme={"red"} variant='outline'>
                                  ندارد
                                </Badge>
                              }</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>صفحه فرود</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.landing ?
                                <Badge ml='1' fontSize='xs' colorScheme={"green"} variant='outline'>
                                  دارد
                                </Badge>
                                :
                                <Badge ml='1' fontSize='xs' colorScheme={"red"} variant='outline'>
                                  ندارد
                                </Badge>
                              }</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>تور مجازی</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.tour == -1 ? "نامحدود" : item.tour + " مورد"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>ایستگاه در هر نمایشگاه</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.room == -1 ? "نامحدود" : item.room + " مورد"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>منو در هر نمایشگاه</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.menu == -1 ? "نامحدود" : item.menu + " مورد"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>پاپ آپ در هر نمایشگاه</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.popup == -1 ? "نامحدود" : item.popup + " مورد"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>مارکر در هر ایستگاه</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.marker == -1 ? "نامحدود" : item.marker + " مورد"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>فایل</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{item.file > 1000 ? item.file / 1000 + " گیگابایت" : item.file == -1 ? "نامحدود" : item.file + " مگابایت"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>دوره</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>{ item.duration+" روز"}</Td>
                            )
                          })}
                        </Tr>
                        <Tr fontSize={"xs"}>
                          <Td>قیمت</Td>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>
                                {item.price > 0 ?

                                  <Badge ml='1' fontSize='xs' p="5px 10px" colorScheme={"blue"} variant='outline'>
                                    {item.price<1000?item.price+" تومان" :item.price<1000000? item.price / 1000 + " هزار تومان":item.price / 1000000 + " میلیون تومان"}
                                  </Badge>
                                  :
                                  item.price == -2 ?
                                    <Badge ml='1' fontSize='xs' p="5px 10px" colorScheme={"blue"} variant='outline'>
                                      {"تماس بگیرید"}
                                    </Badge>
                                    :
                                    <Badge ml='1' fontSize='xs' p="5px 10px" colorScheme={"green"} variant='outline'>
                                      {"رایگان"}
                                    </Badge>
                                }

                              </Td>
                            )
                          })}
                        </Tr>
                        <Tr>
                          <Th></Th>
                          {reportData && reportData.plans.map((item) => {
                            if(item.trial == true && me.trial != 0) return;
                            return (
                              <Td>
                                {item.price != -2 ?
                                  <NiceButton
                                    
                                    isLoading={isActiveLoading[item._id]}
                                    onClick={() => {setSelected(item); onOpen()}}
                                    color={colorMode == "dark" ? "#fff" : "#fff"}
                                    variant='solid'
                                    p={"0px 30px"}
                                    fontSize={"sm"}
                                    bg={"blue.500"}
                                  >
                                    فعالسازی
                                  </NiceButton>
                                  :
                                <Button
                                  color={colorMode == "dark" ? "#fff" : "#fff"}
                                  variant='solid'
                                  onClick={() => { history.push("/admin/support") }}
                                  p={"0px 30px"}
                                  fontSize={"sm"}
                                  bg={"blue.500"}>
                                  تماس با ما
                                </Button>
                                  }
                              </Td>

                            )
                          })}
                        </Tr>
                      </Tbody>
                      <Tfoot>
                      </Tfoot>
                    </Table>
                  </Scrollbars>
                </TableContainer>
              </Box>
            </CardBody>
          </Card>
        </GridItem>
      </SimpleGrid>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >فعالسازی</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            آیا مایل به فعالسازی پلن "{selected?.title}" را به قیمت {selected?.price<1000?selected?.price+" تومان" :selected?.price<1000000? selected?.price / 1000 + " هزار تومان":selected?.price / 1000000 + " میلیون تومان"} فعال کنید؟
          </ModalBody>
          <ModalFooter>
          <Button color={colorMode === "dark" ? "white" : "black"} fontSize='xs' onClick={onClose}>لغو</Button>
            <NiceButton
              mr={"10px"}
              color={colorMode === "dark" ? "white" : "black"}
              onClick={()=>{active_plan()}}
              fontSize='xs'
              w="100px"
            >
              تایید
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default Profile;
